module.exports = __webpack_public_path__ + "static/media/title_marquee_DO.557c52bd.jpg";